import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
// import Landing from "./components/Landing";
import Information from "./components/Information";
import Login from "./components/Login";
import Signup from "./components/Signup";
import UserDashboard from "./components/Dashboard/UserDashboard";
import Protected from "./components/Protected";
import InConstruction from "./components/InConstruction";
import NotFound from "./components/404";
import About from "./components/About";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { Testimonials } from "./components/ReviewGroup";
import Cities from "./components/Cities/Cities";
import ReactGA from "react-ga4";
import SEO from "./components/SEO";
import Contact from "./components/Contact";

const seoData = {
  "/": {
    title: null,
    description:
    "Raven Support Network empowers immigrants and international students to thrive in Canada through dedicated relocation support, career coaching, and deep community integration. Whether you are arriving in Winnipeg, the Greater Toronto Area, or Vancouver, we provide the local expertise and personal advocacy needed to turn a new country into a true home.",
  },
  "/about": {
    title: "About Us",
    description:
      "Meet the founders of Raven Support Network and learn about our mission to help newcomers settle into Canada peacefully and without exploitation.",
  },
  "/contact": {
    title: "Contact Us",
    description:
      "Get in touch with Raven Support Network for personalized immigration settlement support in Winnipeg, Toronto, and Vancouver.",
  },
  "/testimonials": {
    title: "Testimonials",
    description:
      "Read real stories from newcomers who settled into Canada with the help of Raven Support Network.",
  },
  "/cities": {
    title: "Our Locations",
    description:
      "Raven Support Network operates in Winnipeg, Greater Toronto and Hamilton Area, and Metro Vancouver to help newcomers settle into Canada.",
  },
};

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  const currentSeo = seoData[location.pathname];

  return (
    <div className="App">
      <ScrollToTop />
      {currentSeo && (
        <SEO
          title={currentSeo.title}
          description={currentSeo.description}
          path={location.pathname}
        />
      )}
      <Routes>
        {/* <Route path="/" element={<Landing />} /> */}
        <Route path="/" element={<Information />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/cities" element={<Cities />} />
        <Route
          path="/dashboard"
          element={
            <Protected>
              <UserDashboard />
            </Protected>
          }
        />
        <Route path="/apply" element={<InConstruction />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default App;
